import { render, staticRenderFns } from "./XhUser.vue?vue&type=template&id=4779aca8&scoped=true&"
import script from "./XhUser.vue?vue&type=script&lang=js&"
export * from "./XhUser.vue?vue&type=script&lang=js&"
import style0 from "./XhUser.vue?vue&type=style&index=0&id=4779aca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4779aca8",
  null
  
)

component.options.__file = "XhUser.vue"
export default component.exports